import axios from 'axios';
import {
  GET_EVENTS,
  GET_EVENTS_LIST,
  GET_EVENTS_MINIMAL,
  GET_EVENT,
  ADD_EVENT,
  DELETE_EVENT,
  UPDATE_EVENT,
  EVENTS_LOADING,
  EVENT_LOADING,
  CLEAR_CURRENT_EVENT,
  SET_EVENTS_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get lightweight events list with pagination and filtering (for table display)
export const getEventsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setEventsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;

  if (filters.title && filters.title.length > 0) {
    const encodedTitles = filters.title.map(title => encodeURIComponent(title));
    queryParams += `&title=${encodedTitles.join(',')}`;
  }
  if (filters.type && filters.type.length > 0) {
    const encodedTypes = filters.type.map(type => encodeURIComponent(type));
    queryParams += `&type=${encodedTypes.join(',')}`;
  }
  if (filters.status && filters.status.length > 0) {
    const encodedStatuses = filters.status.map(status => encodeURIComponent(status));
    queryParams += `&status=${encodedStatuses.join(',')}`;
  }
  if (filters.program && filters.program.length > 0) {
    filters.program.forEach(programId => {
      queryParams += `&program=${encodeURIComponent(programId)}`;
    });
  }
  if (filters.startDate) {
    queryParams += `&startDate=${encodeURIComponent(filters.startDate)}`;
  }
  if (filters.endDate) {
    queryParams += `&endDate=${encodeURIComponent(filters.endDate)}`;
  }

  axios
    .get(`/api/events/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_EVENTS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single event by ID (for view/edit pages)
export const getEvent = (id) => (dispatch, getState) => {
  dispatch(setEventLoading());
  axios
    .get(`/api/events/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_EVENT, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current event
export const clearCurrentEvent = () => {
  return { type: CLEAR_CURRENT_EVENT };
};

// Get minimal events list (for dropdowns/selectors - returns only _id and title)
export const getEventsMinimal = () => (dispatch, getState) => {
  dispatch(setEventsLoading());
  axios
    .get('/api/events/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_EVENTS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// DEPRECATED: Use getEventsList() instead
export const getEvents = (programId = '') => (dispatch, getState) => {
  dispatch({ type: EVENTS_LOADING });
  const url = programId ? `/api/events?program=${programId}` : '/api/events';
  axios
    .get(url, tokenConfig(getState))
    .then(res => dispatch({ type: GET_EVENTS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addEvent = event => (dispatch, getState) => {
  return axios
    .post('/api/events', event, tokenConfig(getState))
    .then(res => {
      dispatch({ type: ADD_EVENT, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err; // Re-throw to allow component to handle specific errors
    });
};

export const updateEvent = (id, event) => (dispatch, getState) => {
  return axios
    .put(`/api/events/${id}`, event, tokenConfig(getState))
    .then(res => {
      dispatch({ type: UPDATE_EVENT, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err; // Re-throw to allow component to handle specific errors
    });
};

export const deleteEvent = id => (dispatch, getState) => {
  axios
    .delete(`/api/events/${id}`, tokenConfig(getState))
    .then(() => dispatch({ type: DELETE_EVENT, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setEventsLoading = () => {
  return { type: EVENTS_LOADING };
};

export const setEventLoading = () => {
  return { type: EVENT_LOADING };
};

// Set current page number (without fetching data)
export const setEventsPage = (page) => {
  return { type: SET_EVENTS_PAGE, payload: page };
}; 